import React from 'react';
import type { KachelTon } from './kachel';

/**
 * Statuszeile der Hub-Kachel 06 (Stufe B4): farbiger Punkt und der Stand
 * aus `bauordnungKachelText` — „● Entwurf · 4 von 9 Kapiteln". Aussehen wie
 * `PlanungKachelStatus`; was dasteht, entscheidet kachel.ts.
 *
 * Tailwind kompiliert nur Klassen, die WOERTLICH im Quelltext stehen —
 * deshalb ausgeschrieben statt aus dem Ton zusammengesetzt. Der Fehlerpunkt
 * ist grau mit rotem Ring wie bei der Planungs-Ampel: kein Befund, aber
 * auch keine Entwarnung.
 */

const PUNKT: Record<KachelTon, string> = {
    grau: 'bg-slate-300',
    blau: 'bg-blue-500',
    amber: 'bg-amber-400',
    gruen: 'bg-emerald-500',
    fehler: 'bg-slate-400 ring-2 ring-red-200',
};

const TEXT: Record<KachelTon, string> = {
    grau: 'text-slate-500',
    blau: 'text-blue-700',
    amber: 'text-amber-700',
    gruen: 'text-emerald-700',
    fehler: 'text-red-700',
};

export const BauordnungKachelStatus: React.FC<{ text?: string; ton?: KachelTon; laden?: boolean }> = ({ text, ton = 'grau', laden = false }) => {
    if (laden) {
        return (
            <p className="text-[11px] font-semibold text-slate-400 flex items-center gap-1.5">
                <span className={`inline-block w-2 h-2 rounded-full shrink-0 ${PUNKT.grau}`} aria-hidden /> wird gelesen…
            </p>
        );
    }
    if (!text) return null;
    return (
        <p className={`text-[11px] font-semibold flex items-center gap-1.5 ${TEXT[ton]}`} title={text}>
            <span className={`inline-block w-2 h-2 rounded-full shrink-0 ${PUNKT[ton]}`} aria-hidden />
            <span className="truncate">{text}</span>
        </p>
    );
};
